import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { useAppDispatch, useAppSelector } from '@/hooks/redux-hooks';
import { fetchCurrentUser } from '@/store/slices/users/current/actionCreators';
import Loader from '@/uikit/Loader/Loader';
import { deleteCookie } from '@/utils/cookie';

import styles from './styles.module.scss';

const AuthChecking = () => (
  <div className={styles.checking}>
    <Loader className={styles.loader} />
  </div>
);

interface IRequireAuthProps {
  children: JSX.Element;
}

const RequireAuth = ({ children }: IRequireAuthProps) => {
  const location = useLocation();
  const dispatch = useAppDispatch();

  const {
    isLoading,
    error,
  } = useAppSelector((state) => state.currentUserReducer);

  useEffect(() => {
    dispatch(fetchCurrentUser());
  }, []);

  if (isLoading) {
    return <AuthChecking />;
  }
  if (error) {
    deleteCookie('jwt');
    deleteCookie('rt');

    return <Navigate to="/" state={{ from: location }} replace />;
  }
  return children;
};

export default RequireAuth;
